import listSavedFiltersHttpRequest from './02_savedFilters/01_listSavedFilters.thunk';
import createSavedFiltersHttpRequest from './02_savedFilters/02_createSavedFilter.thunk';
import deleteSavedFiltersHttpRequest from './02_savedFilters/03_deleteSavedFilter.thunk';
import updateSavedFiltersHttpRequest from './02_savedFilters/04_updateSavedFilter.thunk';

import myTrialsListHttpRequest from './01_myTrialsList.thunk';

import moduleAccessHttpRequest from './00_moduleAccess.thunk';
import dataSourcesHttpRequest from './04_dataSources.thunk';
import mySiteHealthBookmarkHttpRequest from './05_mySiteHealthBookmark.thunk';

export {
  myTrialsListHttpRequest,
  listSavedFiltersHttpRequest,
  createSavedFiltersHttpRequest,
  deleteSavedFiltersHttpRequest,
  moduleAccessHttpRequest,
  dataSourcesHttpRequest,
  mySiteHealthBookmarkHttpRequest,
  updateSavedFiltersHttpRequest,
};

export const API_LIST = [
  listSavedFiltersHttpRequest,
  createSavedFiltersHttpRequest,
  deleteSavedFiltersHttpRequest,
  myTrialsListHttpRequest,
  moduleAccessHttpRequest,
  dataSourcesHttpRequest,
  mySiteHealthBookmarkHttpRequest,
  updateSavedFiltersHttpRequest,
];
